<template>
    <div class="form-group form-group_modal" :class="{ 'form-group--error': !complete && !init }">
        <label :for="id">{{title}} <span class="color-red">*</span></label>
        <div class="suggest-container">
            <input type="text" class="form-control" :name="title" :id="id"
                   @input="changed($event.target.value)" ref="refInput" @blur="handleBlur"
                   autocomplete="off">
            <div class="suggestions-result"
                 :class="{show: suggestions}">
                <ul class="list-group suggestions-items">
                    <li class="list-group-item suggestions-item" v-for="item in suggestions"
                        @click="setValue(item.ID, item.NAME)">
                        {{ item.NAME }}
                    </li>
                </ul>
            </div>
            <div class="invalid-input" v-if="!complete">
                Выберите город из предложенного списка
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'suggest',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      title: {
        type: String,
        required: true
      },
      value: String,
      init: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        id: this.getUniqueId(),
        complete: false,
        suggestions: []
      }
    },
    methods: {
      setValue (id, name) {
        this.complete = true

        this.$emit('complete', true)
        this.$emit('change', id)
        this.$refs.refInput.value = name
        this.suggestions = []
      },
      changed: _.debounce(function (value) {
        this.init = false
        this.suggestions = []
        this.complete = false

        this.$emit('complete', false)
        this.suggest(value)
      }, 1000),
      suggest (value) {
        if (value) {
          let params = new FormData()
          params.append('cityName', value)
          params.append('ajax', 'Y')
          params.append('count', 5)
          this.$http.post('/ajax/citiesHandler.php', params).then(res => {
            if (res.data.length > 0) {
              this.suggestions = res.data
            }
          })
        }
      },
      handleBlur: function () {
        this.$emit('blur')

        setTimeout(() => {
          this.suggestions = []
        }, 1000)
      },
      getUniqueId: function () {
        /**
         * @return {string}
         */
        function S4 () {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
        }

        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
      }
    }
  }
</script>

<style lang="scss">
    .suggest-container {
        position: relative;
    }

    .suggestions-result {
        display: none;

        &.show {
            z-index: 10;
            display: block;
            position: absolute;
            top: 41px;
            width: 100%;
        }

        .suggestions-item {
            border-radius: 0;
            padding: 2px;
            cursor: pointer;

            &:hover {
                background-color: #d1d3d4;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/vue/components/forms/components/Suggest.vue